export default __webpack_public_path__ + "static/media/logo.0da4b6a5.jpg";